import { render, staticRenderFns } from "./GenerateProductsView.vue?vue&type=template&id=2bf7b7a0&scoped=true&"
import script from "./GenerateProductsView.vue?vue&type=script&lang=js&"
export * from "./GenerateProductsView.vue?vue&type=script&lang=js&"
import style0 from "./GenerateProductsView.vue?vue&type=style&index=0&id=2bf7b7a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf7b7a0",
  null
  
)

export default component.exports